import * as React from 'react'

import { AlertModel } from '@/app/models/alert/alertModel'
import { DriverModel, VehicleModel } from '@/app/models'

import {
  FieldsetSelect,
  Option,
} from '@/modules/settings/components/FieldsetSelect'

import AlertType from './stages/AlertType'
import { AlertFormProvider, useAlertForm } from './AlertFormContext'
import AlertObject from './stages/AlertObject'
import { DividerHorizontal } from '@/modules/drivers/shared/DividerHorizontal'
import AlertDate from './stages/AlertDate'
import AlertInfo from './stages/AlertInfo'
import AlertOptions from './stages/AlertOptions'

type AddAlertFormProps = {
  formId: string
  handleClose: () => void
  onSave?: () => void
  editedAlert?: AlertModel | null
  companyId: string
  drivers: DriverModel[]
  vehicles: VehicleModel[]
  onLoadingChange?: (loading: boolean) => void
}

const AddAlertForm: React.FC<AddAlertFormProps> = ({
  formId,
  handleClose,
  onSave,
  editedAlert,
  companyId,
  drivers,
  vehicles,
  onLoadingChange,
}) => {
  return (
    <AlertFormProvider
      companyId={companyId}
      editedAlert={editedAlert}
      drivers={drivers}
      vehicles={vehicles}
      handleClose={handleClose}
      onSave={onSave}
      onLoadingChange={onLoadingChange}
    >
      <AddAlertFormFields formId={formId} />
    </AlertFormProvider>
  )
}

const AddAlertFormFields: React.FC<{ formId: string }> = ({ formId }) => {
  const { handleSubmit } = useAlertForm()

  return (
    <form
      className="tw-flex tw-flex-col tw-gap-4 tw-overflow-auto tw-p-6"
      id={formId}
      onSubmit={handleSubmit}
      noValidate
    >
      <AlertType />
      <DividerHorizontal />
      <AlertObject />
      <DividerHorizontal />
      <AlertDate />
      <DividerHorizontal />
      <AlertInfo />
      <DividerHorizontal />
      <AlertOptions />
    </form>
  )
}

export default AddAlertForm
